const testdriveContractTemplate = {
    url: `/testdrive-contract-template`,
    method: 'get',
    serverHost: '/backend'
};

const signTestdriveContract = {
    url: `/beyonder/api/v1/esign/sign-testdrive-contract`,
    requstTypeJson: true,
    method: 'post'
};
const testdriveContract = {
    url: `/test-drive-contract/{contract_no}`,
    method: 'get',
    serverHost: '/backend'
};


/**
 * 获取订单维度的特殊电子签配置
 */
const fetchTestdriveESignOrderSpecificConfigData = {
    url: `/beyonder/api/v1/esign/order-specific-configs`,
    method: 'get',
    requstTypeJson: true,
}

export default {
    testdriveContractTemplate,
    signTestdriveContract,
    testdriveContract,
    fetchTestdriveESignOrderSpecificConfigData
};



// WEBPACK FOOTER //
// ./src/service/esign/index.js